import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import Login from "../Login/Login";
import { Button, NavDropdown } from "react-bootstrap";
import "./NavBar.css";
import { useSelector } from "react-redux";

function NavBar() {
  const [LoginBox, setLoginBox] = useState({ Hide: false });

  const IsLogin = useSelector((state) => state.GlobalStatus.data);
  const posts2 = useSelector((state) => state.Login);

  useEffect(() => {
    if (posts2.LoginResponce[1] === "Success") {
      setLoginBox({ Hide: false });
      window.location.assign("/");
    }
  }, [posts2]);

  const HandelLogOut = () => {
    localStorage.clear();
    window.location.assign("/");
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary bg-light">
      <Container fluid>
         <Navbar.Brand href="/">
        <img
          src={`${process.env.REACT_APP_BackEndIP}/Static/Logo/1.png`}
          alt="Logo"
          width="70"
          height="40"
          className="d-inline-block align-center"
        />
      </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar" />
        <Navbar.Collapse id="navbar">
          <Nav className="justify-content-center flex-grow-1 pe-3 me-auto my-2 my-lg-0">
            <Nav.Link as={Link} to="/">
              Gallery
            </Nav.Link>

            {IsLogin["IsLogedIn"] ? (
              <NavDropdown title="Account" id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to="/Cart">
                  View Cart
                </NavDropdown.Item>
                <NavDropdown.Divider></NavDropdown.Divider>
                <NavDropdown.Item as={Link} to="/Order">
                  View Orders
                </NavDropdown.Item>
              </NavDropdown>
            ) : null}

            <Nav.Link as={Link} to="/About">
              About
            </Nav.Link>

            {(IsLogin["Email"] === "chintanmungra.chintan@gmail.com" || IsLogin["Email"] === "ami.gadhiya64@gmail.com")  ? (
              <NavDropdown title="Admin" id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to="/AdminUpdateGallery">
                  Update Gallery
                </NavDropdown.Item>
                <NavDropdown.Divider></NavDropdown.Divider>
                <NavDropdown.Item as={Link} to="/AdminCustomerOrders">
                  Customer Orders
                </NavDropdown.Item>
              </NavDropdown>
            ) : null}
          </Nav>
          {IsLogin["IsLogedIn"] ? (
            <Button className="Button06" onClick={HandelLogOut}>
              LogOut
            </Button>
          ) : (
            <Button
              className="Button06"
              onClick={() => setLoginBox({ Hide: true })}
            >
              Login
            </Button>
          )}
        </Navbar.Collapse>

        <Login
          show={LoginBox["Hide"]}
          onHide={() => setLoginBox({ Hide: false })}
        />
      </Container>
    </Navbar>
  );
}

export default NavBar;
